// components/Separator.js
import React from 'react';

function Separator() {
  return <div className="section-separator"></div>;
}

export default Separator;
